<nz-modal
    [(nzVisible)]="isVisible"
    nzTitle=""
    [nzMaskClosable]="false"
    (nzOnCancel)="handleClose()"
    nzClassName="confirm-dialog"
    [nzFooter]="null"
>
    <div *nzModalContent class="content">
        <div class="title">
            <i
                nz-icon
                nzType="question-circle"
                nzTheme="twotone"
                [nzTwotoneColor]="'#ff902b'"
                class="icon"
            ></i>
            <div class="message">{{ message }}</div>
        </div>

        <div class="action">
            <button
                nz-button
                class="text-btn-danger"
                (click)="handleCancel()"
                [nzLoading]="cancelLoading"
                [disabled]="overwriteLoading || keepLoading"
            >
                {{ cancelText }}
            </button>
            <button
                nz-button
                class="text-btn-primary"
                (click)="handleReplace()"
                [nzLoading]="overwriteLoading"
                [disabled]="cancelLoading || keepLoading"
            >
                {{ overwriteText }}
            </button>
            <button
                nz-button
                class="text-btn-green"
                (click)="handleKeep()"
                [nzLoading]="keepLoading"
                [disabled]="overwriteLoading || cancelLoading"
            >
                {{ keepText }}
            </button>
        </div>
    </div>
</nz-modal>
